import { seriesData } from "../../../mocks/fortyone";

export default function SeriesSection() {
  return (
    <section id="series" className="py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide whitespace-nowrap">
              <i className="ri-archive-line"></i>
              往期系列合集
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
              六大系列，持续沉淀
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl">
              每个系列都是一个长期更新的内容栏目，同类话题持续归档，越翻越有料。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {seriesData.map((s, i) => (
            <a
              href="#recap"
              key={s.name}
              className="group rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 p-5 md:p-6 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg font-heading font-bold">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="px-2.5 py-1 rounded-full bg-background-100 text-foreground-500 text-xs font-medium whitespace-nowrap">
                  {s.count}
                </span>
              </div>
              <div className="mt-4 flex items-center gap-2">
                <h3 className="text-lg font-bold text-foreground-950">{s.name}</h3>
                <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                  {s.tag}
                </span>
              </div>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all whitespace-nowrap">
                进入系列回看 <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}